function NRBinaryIcon({ height = '18', width = '18', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} aria-hidden="true" focusable="false" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM18 12H6V10H18V12ZM14 16H6V14H14V16Z"
        fill={color}
      />
    </svg>
  );
}
export default NRBinaryIcon;
